// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__NElhb","content":"style__content__JXC3C","footer":"style__footer__g6emT"};